(() => {
  angular
    .module('gm.common.redeem', [])
    .value('CoinUrls', {
      '.05MAP': '/physical/gold-bullion/coins/1-20-canadian-maple-leaf',
      '.1MAP': '/physical/gold-bullion/coins/1-10-canadian-maple-leaf',
      '.25MAP': '/physical/gold-bullion/coins/1-4-canadian-maple-leaf',
      '.5MAP': '/physical/gold-bullion/coins/1-2-canadian-maple-leaf',
      '1MAP': '/physical/gold-bullion/coins/canadian-maple-leaf',
      '.5EAGLE': '/physical/gold-bullion/coins/1-2-american-eagle',
      '1EAGLE': '/physical/gold-bullion/coins/american-eagle',
      '.5KANG': '/physical/gold-bullion/coins/1-2-australian-kangaroo',
      '1KANG': '/physical/gold-bullion/coins/australian-kangaroo',
      '.5PHIL': '/physical/gold-bullion/coins/1-2-austrian-philharmonic',
      '1PHIL': '/physical/gold-bullion/coins/austrian-philharmonic',
      '.5KR': '/physical/gold-bullion/coins/1-2-south-african-krugerrand',
      '1KR': '/physical/gold-bullion/coins/south-african-krugerrand',
      '.5PANDA': '/physical/gold-bullion/coins/chinese-panda',
      '1PANDA': '/physical/gold-bullion/coins/chinese-panda',
      '1KILOG': '/physical/gold-bullion/bars/1-kilo',
      '10PAMP': '/physical/gold-bullion/bars/pamp-suisse',
      '1PAMP': '/physical/gold-bullion/bars/pamp-suisse/1-oz',
      '1AGMAP': '/physical/silver-bullion/coins/1-oz-silver-canadian-maple-leaf',
      '1AGREC': '/physical/silver-bullion/bars',
      '10AG': '/physical/silver-bullion/bars',
      '100AG': '/physical/silver-bullion/bars',
      '10GRBG1C': '/physical/gold-bullion/cubes',
      '10GRBG2C': '/physical/gold-bullion/cubes',
      '10GRBG3C': '/physical/gold-bullion/cubes',
      '10GRBG4C': '/physical/gold-bullion/cubes',
      '100GRGBBG': '/physical/gold-bullion/cubes',
    })
    .factory('GmyRedeem', GmyRedeem);

  function GmyRedeem(
    $q,
    $filter,
    btgUser,
    gmApi,
    promiseCache,
    CoinUrls
  ) {
    'ngInject';

    return {
      getShippingAddress,
      getPhysicalRedemptionCatalog,
      getItemDetails,
      getPhysicalRedemptionShipping,
      getTshirtsCatalog,
      requestBankWireRedemption,
      requestPhysicalBarRedemption,
      requestPhysicalCubeRedemption,
      requestPhysicalRedemption,
      requestV2VRedemption,
      requestTrustlyRedemptionURL,
      requestWealthRedemption,
    };

    function getCachedCatalog() {
      return promiseCache({
        promise: () => gmApi.get('dillongage/catalog')
        .then(response => response.items.map(setDetails)),
        ttl: 60000
      });
    }

    function getShippingAddress() {
      const profile = btgUser.getProfile();
      return {
        street1: profile.street,
        street2: profile.streetLine2,
        city: profile.city,
        state: profile.stateOrProvince,
        country: profile.countryCode,
        ZIP: profile.zipOrPostalCode
      };
    }

    function getItemDetails(code) {
      return getCachedCatalog().then((items) => {
        const filteredItems = items.filter(item => item.code === code);
        return filteredItems ? filteredItems[0] : null;
      });
    }

    function getPhysicalRedemptionCatalog(category) {
      return gmApi.get('dillongage/catalog', { params: { category } })
      .then(response => response.items.map(setDetails));
    }

    function getTshirtsCatalog() {
      return gmApi.get('dillongage/tshirts')
      .then(response => response.items.map(setDefaultImage));
    }

    function getPhysicalRedemptionShipping(items) {
      if (Object.keys(items).length === 0) {
        return $q.when({ amount: null });
      }
      return gmApi.post('dillongage/shipping', { items }, { auth: true });
    }

    function requestBankWireRedemption(data, twoFactAuth) {
      return gmApi.post('redemption/redeem/bankWire', data, { twoFactAuth, auth: true });
    }

    function requestPhysicalBarRedemption(numberOfBars, vaultId, date, pickupTime, twoFactAuth) {
      const pickupDate = $filter('date')(date, 'yyyy-MM-dd');
      const data = {
        numberOfBars,
        pickupDate,
        pickupTime,
        vaultId,
      };
      return gmApi.post('redemption/redeem/bar', data, { twoFactAuth, auth: true });
    }

    function requestPhysicalCubeRedemption(numberOfCubes, vaultId, addressInfo, twoFactAuth) {
      const data = angular.extend({
        numberOfCubes,
        vaultId
      }, addressInfo);
      return gmApi.post('redemption/redeem/cube', data, { twoFactAuth, auth: true });
    }

    function requestPhysicalRedemption(items, vaultId, twoFactAuth) {
      const data = { items, vaultId };
      return gmApi.post('redemption/redeem/dillongage', data, { twoFactAuth, auth: true });
    }

    function requestTrustlyRedemptionURL(data, twoFactAuth) {
      return gmApi.post('redemption/redeem/trustly', data, { twoFactAuth, auth: true });
    }

    function requestV2VRedemption(data, twoFactAuth) {
      return gmApi.post('redemption/redeem/vault', data, { twoFactAuth, auth: true });
    }

    function requestWealthRedemption(data, twoFactAuth) {
      const options = { twoFactAuth, auth: true };
      return gmApi.post('redemption/redeem/wealth', data, options);
    }

    function setDetails(item) {
      setDetailUrl(item);
      setDefaultImage(item);
      setDetailedDescription(item);
      return item;
    }

    function setDefaultImage(item) {
      item.defaultImage = item.images.find(img => img.imgType === 'default');
      return item;
    }

    function setDetailedDescription(item) {
      item.detail = `${item.weight} ${item.purity}`;
    }

    function setDetailUrl(item) {
      item.detailUrl = CoinUrls[item.code];
      return item;
    }
  }
})();
